import { defineStore, acceptHMRUpdate } from 'pinia';
import utilitiesData from '../../utilities/common/data';
import LoginRepository from '../../repositories/auth/LoginRepository';

const dataLogin = {
  username: null,
  password: null,
};

export const useLoginStore = defineStore('LoginStore', {
  state: () => ({
    isSuccess: false,
    isAuth: true,
    hasErrorSingle: null,
    // form page
    formData: structuredClone(dataLogin),
    hasFormError: structuredClone(dataLogin),
    isLoadingForm: false,
  }),
  actions: {
    async checkAuth() {
      try {
        const loginSystem = await LoginRepository.checkAuth();
        if (loginSystem.data.status === 200) {
          this.isAuth = true;
        }
      } catch (error) {
        this.isAuth = false;
      }
    },
    async login() {
      try {
        this.isLoadingForm = true;
        this.isSuccess = false;
        this.resetForm(false, false);

        const params = this.formData;
        const loginSystem = await LoginRepository.login(params);
        if (loginSystem.data.status === 200) {
          localStorage.setItem('login-token', loginSystem.data.data.login_token);
          this.isAuth = true;
          this.isSuccess = true;
          this.resetForm();
        }
      } catch (error) {
        console.log(error);
        this.isAuth = false;
        this.setFormError(error.response.data.error);
        this.isSuccess = false;
        this.isLoadingForm = false;
      }
    },
    setFormError(error) {
      if (typeof error === 'string' || error instanceof String) {
        this.hasErrorSingle = error;
      } else {
        Object.keys(error).forEach((item) => {
          this.hasFormError[item] = error[item][0];
        });
      }
    },
    resetForm(withContent = true, withLoading = true) {
      if (withContent) {
        this.formData = structuredClone(dataLogin);
      }
      this.hasFormError = structuredClone(dataLogin);
      this.hasErrorSingle = null;
      if (withLoading) {
        this.isLoadingForm = false;
      }
    },
    removeErrorFormSingle(key) {
      this.hasFormError[key] = null;
    },
    async logout() {
      try {
        this.isSuccess = false;

        const loginSystem = await LoginRepository.logout();
        if (loginSystem.data.status === 200) {
          localStorage.removeItem('login-token');
          this.isAuth = false;
          this.isSuccess = true;
        }
      } catch (error) {
        console.log(error);
        this.isSuccess = false;
      }
    },
  },
  getters: {
    isAuthenticated(state) {
      return state.isAuth;
    },
  },
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(useLoginStore, import.meta.webpackHot));
}
